import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Reply icon — leftward arrow with a return curve.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const ReplyIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14.4999 13.3329C14.4999 12.1627 14.0234 11.4795 13.4579 11.0721C12.8668 10.6466 12.1424 10.499 11.6669 10.4989H6.20691L8.6864 12.9794C8.88167 13.1746 8.88167 13.4911 8.6864 13.6864C8.49112 13.8813 8.17453 13.8816 7.97937 13.6864L4.64637 10.3524C4.45127 10.1571 4.45116 9.8406 4.64637 9.64539L7.97937 6.31238C8.17458 6.11717 8.49113 6.11728 8.6864 6.31238C8.88167 6.50764 8.88167 6.82415 8.6864 7.01941L6.20691 9.4989H11.6669C12.3023 9.49897 13.2444 9.68559 14.0419 10.2596C14.8651 10.8523 15.4999 11.8366 15.4999 13.3329C15.4997 13.6089 15.2759 13.8329 14.9999 13.8329C14.7238 13.8329 14.5001 13.6089 14.4999 13.3329Z"
      fill="currentColor"
    />
  </svg>
);

export default ReplyIcon;
